<script>
	import { createEventDispatcher, onMount } from 'svelte';
	import { replace } from 'svelte-spa-router';
	import { 
		gerarStringAleatoria, 
		StatusHttp, 
		TipoEvento,
		API, 
		TextoFeedback, 
		TipoPerfil } from '../../utils';
	import { sCaptcha } from '../../stores';
	import TBox from '../templates/TBox.svelte';
	import Captcha from '../../componentes/Captcha.svelte';

	const dispatch = createEventDispatcher();
	
	// variáveis para trabalhar com os dados do formulário
	let nome, email, cpf, matricula, perfil, unidade, area_interesse, senha, senha_confirmation, captchaUsuario;

	let tituloAviso = "Erro";
	let feedbackUsuario = [];
	let perfis = [];
	let unidades = [];
	let areas_interesse = [];
	let informacosAPICache = null;
	let perfilAvaiadorSelecionado;

	onMount(async () => {
		informacosAPICache = JSON.parse(localStorage.getItem('AVAL_API_INFO_CACHE'));

		if (informacosAPICache == undefined)
			replace("/");
		else {
			perfis = Object.entries(informacosAPICache.perfis).sort();
			areas_interesse = Object.entries(informacosAPICache.areas_conhecimento).sort();
			
			/**
			 * unidades já estão ordenadas pelo nome no back-end, não é respeitado o nome
			 * da unidade com a sigla da unidade, ordenar via js gera uma ordenação com falha.
			 */
			unidades = Object.entries(informacosAPICache.unidades);
		}
	});

	async function submeterFormulario(event) {
		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Enviando os dados ...',
		});
			
		if (captchaUsuario != $sCaptcha) {
			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});
			
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Captcha Inválido',
				conteudo: 'O código informado é inválido, tente novamente.'
			});
			
			// atualiza o store
			sCaptcha.update(novaString => gerarStringAleatoria());
		} else {
			// faz a chamada a API no endpoint cadastrar, envia os dados e aguarda a resposta
			// IMPORTANTE: não é enviado token pois o usuário ainda não possui! Nas demais funcionalidades, o token deve ser enviado junto da requisição.
			const resposta = await fetch(API('usuarios'), {
				method: 'POST',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					nome: nome,
					email: email,
					cpf: String(cpf),
					matricula: String(matricula),
					perfis: perfil,
					unidade: unidade,
					area_interesse: area_interesse,
					senha: senha,
					senha_confirmation: senha_confirmation
				})
			}).catch(erros => {
				console.log(erros);

				feedbackUsuario.push(TextoFeedback.ERRO_REQUISICAO);
				
				dispatch('routeEvent', { 
					tipo: TipoEvento.ESTA_CARREGANDO,
					valor: false
				});
				
				dispatch('routeEvent', {
					tipo: TipoEvento.ABRIR_MODAL,
					titulo: tituloAviso,
					conteudo: feedbackUsuario[0]
				});
			});

			// pega o json do retorno da resposta
			const json = await resposta.json();

			if (resposta.status == StatusHttp.CREATED) {		
				localStorage.setItem('AVAL_CADASTRO_EXTRATO', JSON.stringify(json.dados));
				replace('/acesso/ativacao');
			} else if (resposta.status == StatusHttp.UNPROCESSABLE_ENTITY) {
				tituloAviso = 'Verifique os dados informados!'
				feedbackUsuario.push(json?.mensagem);
			} else {
				console.log('erro desconhecido...');
				feedbackUsuario.push('Erro desconhecido, se persistir, favor entrar em contato.');
			}

			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});

			// exibe feedback pro usuário se existir algo pra exibir
			if (feedbackUsuario[0]) {
				dispatch('routeEvent', {
					tipo: TipoEvento.ABRIR_MODAL,
					titulo: tituloAviso,
					conteudo: feedbackUsuario[0]
				});
			}

			// limpa as mensagens
			feedbackUsuario = [];
		}
	}

	const exibirAreaInteresseAvaliador = (evento) => {
		if (perfil == TipoPerfil.AVALIADOR)
			perfilAvaiadorSelecionado = true;
		else
			perfilAvaiadorSelecionado = false;
	}
</script>

<TBox 
	titulo="Cadastro" 
	subtitulo="Faça seu cadastro para utilizar o sistema" 
	largura="8" 
	deslocamento="2" 
	correcaoY="-13px"
	icone="cadastro">

	<form method="post" on:submit|preventDefault={submeterFormulario}>
		<div class="columns">
			<div class="column is-full">
				<small class="has-text-primary">Nome completo:</small>
				<div class="field">
					<input 
						bind:value={nome}
						name="nome" 
						type="text" 
						placeholder="Nome completo" 
						class="input is-large is-primary" 
						autocomplete="name" required>
				</div>
			</div>
		</div>

		<div class="columns">
			<div class="column is-half">
				<small class="has-text-primary">CPF (apenas números):</small>
				<div class="field">
					<input 
						bind:value={cpf}
						name="cpf"
						type="tel" 
						pattern="[0-9]*" 
						maxlength="11" 
						placeholder="CPF (apenas números)" 
						class="input is-large is-primary" 
						autocomplete="cpf" required>
				</div>
			</div>
		
			<div class="column is-half">
				<small class="has-text-primary">Matrícula (apenas números):</small>
				<div class="field">
					<input 
						bind:value={matricula}
						name="matricula"
						type="tel" 
						pattern="[0-9]*" 
						maxlength="30" 
						placeholder="Matrícula (apenas números)" 
						class="input is-large is-primary" required>
				</div>
			</div>
		</div>
		
		<div class="columns">
			<div class="column is-4">
				<small class="has-text-primary">E-mail:</small>
				<div class="field">
					<input 
						bind:value={email} 
						name="email"
						type="email" 
						class="input is-large is-primary" 
						placeholder="Email" 
						autocomplete="email" required>
				</div>
			</div>

			<div class="column is-4">
				<small class="has-text-primary">Perfil de acesso:</small>
				<div class="select is-primary is-large is-fullwidth">
					<select bind:value={perfil} name="perfil" on:change={exibirAreaInteresseAvaliador} required>
						<option value="">Escolha um perfil...</option>
						{#each perfis as [chave, valor]}
						<option value="{chave}">{valor}</option>
						{/each}
					</select>
				</div>
			</div>

			<div class="column is-4">
				<small class="has-text-primary">Unidade:</small>
				<div class="select is-primary is-large is-fullwidth">
					<select bind:value={unidade} name="unidade" required>
						<option value="">Escolha uma unidade...</option>
						{#each unidades as [chave, valor]}
						<option value="{chave}">{valor}</option>
						{/each}
					</select>
				</div>
			</div>
		</div>
		
		{#if perfilAvaiadorSelecionado}
		<div class="columns">
			<div class="column">
				<small class="has-text-primary">Área de interesse:</small>
				<div class="select is-primary is-large is-fullwidth">
					<select bind:value={area_interesse} name="area_interesse" required>
						<option value="">Selecione uma área de interesse...</option>
						{#each areas_interesse as [chave, valor]}
						<option value="{chave}">{valor}</option>
						{/each}
					</select>
				</div>
			</div>
		</div>
		{/if}

		<div class="columns">
			<div class="column is-half">
				<small class="has-text-primary">Crie uma senha:</small>
				<div class="field">
					<input 
						bind:value={senha} 
						name="senha" 
						type="password" 
						class="input is-large is-primary" 
						placeholder="Senha" 
						autocomplete="current-password" required>
				</div>
			</div>

			<div class="column is-half">
				<small class="has-text-primary">Digite a senha novamente:</small>
				<div class="field">
					<input 
						bind:value={senha_confirmation}
						name="senha_confirmation" 
						type="password" 
						class="input is-large is-primary" 
						placeholder="Repetir senha" required>
				</div>
			</div>
		</div>

		<div class="columns is-mobile">
			<div class="column">
				<small class="has-text-primary">Verificação...</small>
				<Captcha />
			</div>
			<div class="column">
				<small class="has-text-primary">Confirme o código de verificação:</small>
				<input 
					name="captcha"
					bind:value={captchaUsuario}
					type="text"
					maxlength="8" 
					placeholder="Digite o código aqui" 
					class="input is-large is-primary" required>
			</div>
		</div>

		<div class="columns">
			<div class="column">
				<p class="control">
					<a href="#/" class="button is-black is-medium is-outlined is-fullwidth">Início</a>
				</p>
			</div>
			<div class="column is-8">
				<p class="control">
					<button 
						type="submit" 
						class="button is-primary is-medium is-fullwidth">
						Cadastrar
					</button>
				</p>
			</div>
		</div>
	</form>
</TBox>